import { Queue } from '@cian/event-queue';

import { type TEvents } from 'shared/types/events';

/**
 * Возвращает общий для страницы экземпляр очереди событий.
 *
 * В браузере очередь обязана быть одна на всех: микрофронтенды публикуют события
 * в `window.eventQueue`. Поэтому при отсутствии очереди мы её создаём и кладём
 * обратно на `window` — иначе хост подпишется на выброшенный экземпляр и события
 * молча не придут. Вне браузера возвращаем отдельную очередь-заглушку.
 */
export function getEventQueue(): Queue<TEvents> {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue<TEvents>());
  }

  return new Queue<TEvents>();
}
